document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-wm-home]').forEach((home) => {
    const filters = home.querySelectorAll('[data-wm-filter]');
    const products = home.querySelectorAll('[data-wm-product]');
    const status = home.querySelector('[data-wm-filter-status]');

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        const selected = button.dataset.wmFilter;
        let visible = 0;
        filters.forEach((filter) => {
          const active = filter === button;
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', String(active));
        });
        products.forEach((product) => {
          const hidden = selected !== 'all' && product.dataset.category !== selected;
          product.hidden = hidden;
          if (!hidden) visible += 1;
        });
        if (status) status.textContent = `Showing ${visible} featured products.`;
      });
    });

    const jokes = [
      ['I told my 3D printer a joke.', 'It needed a minute to process it.'],
      ['My 3D printer and I have a lot in common.', 'We both work better after a good restart.'],
      ['Why did the collector bring a ladder?', 'To take the collection to the next level.'],
      ['I tried to write a joke about filament.', 'It turned into a long thread.']
    ];
    const joke = home.querySelector('[data-wm-joke]');
    const nextJoke = home.querySelector('[data-wm-next-joke]');
    let jokeIndex = 0;
    if (joke && nextJoke) {
      nextJoke.addEventListener('click', () => {
        jokeIndex = (jokeIndex + 1) % jokes.length;
        joke.replaceChildren(document.createTextNode(jokes[jokeIndex][0]), document.createElement('br'), document.createTextNode(jokes[jokeIndex][1]));
      });
    }
  });
});


(() => {
  const rotate = (home) => {
    const slot = home.querySelector('[data-wm-hero-slot]');
    const options = [...home.querySelectorAll('template[data-wm-hero-option]')];
    if (!slot || !options.length) return;
    const key = 'wm-home-last-featured';
    let previous = '';
    try { previous = sessionStorage.getItem(key) || ''; } catch {}
    const pool = options.length > 1 ? options.filter(option => option.dataset.productId !== previous) : options;
    const selected = pool[Math.floor(Math.random() * pool.length)] || options[0];
    const card = selected.content.cloneNode(true);
    slot.replaceChildren(card);
    try { sessionStorage.setItem(key, selected.dataset.productId); } catch {}
  };
  const init = () => document.querySelectorAll('[data-wm-home]').forEach(rotate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => {
    const home = event.target.querySelector('[data-wm-home]');
    if (home) rotate(home);
  });
})();
